import React from 'react';
import PropTypes from 'prop-types';

import './stock-photo-label.scss';

export function StockPhotoLabel({ isMobile = false }) {
  return (
    <div
      className="pos-a stock-photo-label  my-xl-0_75"
      style={{
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        letterSpacing: '0',
        marginTop: '24px ',
        marginBottom: '24px ',
        right: '0.5rem',
        ...(isMobile ? {} : { bottom: 0 }),
      }}
    >
      <div
        className="stock-photo-text"
        style={{
          textAlign: 'left',
          display: 'inline-block',
          paddingRight: '8px',
          paddingLeft: '8px',
        }}
      >
        Stock photo; photos of advertised vehicle are not available.<sup>**</sup>
      </div>
    </div>
  );
}

StockPhotoLabel.propTypes = { isMobile: PropTypes.bool };
